import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { ButtonGrid } from "@sonder/ui/source/styled/fragments/ButtonGrid";

const StyledButtonGridWrapper = styled.div`
  height: 2.3rem;
  padding: 0.5rem 0;
  position: relative;
  width: 100%;
`;

const StyledButtonGridContentLoader = styled(ContentLoader)`
  border-radius: 0.3rem;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
`;

export const ButtonGridContentLoader = () => (
  <StyledButtonGridWrapper>
    <StyledButtonGridContentLoader
      preserveAspectRatio="none"
      viewBox="0 0 100 100"
    >
      <rect fill="black" height="100%" width="100%" x="0" y="0" />
    </StyledButtonGridContentLoader>
  </StyledButtonGridWrapper>
);

export const ButtonGridMultiContentLoader = () => (
  <ButtonGrid>
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
    <ButtonGridContentLoader />
  </ButtonGrid>
);
